import { useSelector, useDispatch } from 'react-redux';
import {
  deletedNotifications,
  getNotificationsData,
  getUnreadNotificationsData,
  markAsReadNotifications,
  markAsUnReadNotifications,
  setCurrentPage,
  setPageSize
} from 'store/Notifications';

function useNotifications() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.notifications?.ui?.loading);
  const rawData = useSelector((state) => state?.notifications?.data || []);
  const unreadNotifications = useSelector((state) => state?.notifications?.unread || []);
  const notificationsTotalPages = useSelector((state) => state?.notifications?.pagination?.totalRecords || 0);
  const notificationsPageSize = useSelector((state) => state?.notifications?.pagination?.pageSize || 10);
  const notificationsCurrentPage = useSelector((state) => state?.notifications?.pagination?.currentPage || 1);

  const getNotificationsDataAction = (params) => dispatch(getNotificationsData(params));
  const getUnreadNotificationsDataAction = (params) => dispatch(getUnreadNotificationsData(params));
  const markAsReadNotificationsAction = (params) => dispatch(markAsReadNotifications(params));
  const markAsUnReadNotificationsAction = (params) => dispatch(markAsUnReadNotifications(params));
  const deletedNotificationsAction = (params) => dispatch(deletedNotifications(params));
  const setCurrentPageAction = (index) => dispatch(setCurrentPage(index));
  const setPageSizeAction = (index) => dispatch(setPageSize(index));

  return {
    loading,
    rawData,
    unreadNotifications,
    notificationsTotalPages,
    notificationsPageSize,
    notificationsCurrentPage,

    getNotificationsDataAction,
    getUnreadNotificationsDataAction,
    markAsReadNotificationsAction,
    markAsUnReadNotificationsAction,
    deletedNotificationsAction,
    setCurrentPageAction,
    setPageSizeAction
  };
}

export default useNotifications;
